<template>
	<div class="wrap">
		<div class="section_point">
			<h2 class="report_title">투자 포인트</h2>
			<div
				v-if="investReportPointData?.invest_point"
				v-dompurify-html="investReportPointData.invest_point"
				class="c_editorContent c_editorContent_outline"
			></div>
		</div>
		<div v-if="investReportPointData?.event_issue" class="section_point">
			<h2 class="report_title">종목이슈</h2>
			<div v-if="investReportPointData?.event_issue.length > 0" class="point_item">
				<div
					v-for="(item, index) in investReportPointData.event_issue
						.slice()
						.sort((a, b) => new Date(b.event_issue_date).getTime() - new Date(a.event_issue_date).getTime())
						.slice(0, exposure.count_issue)"
					:key="`issue${index}`"
					class="c_editorContent c_editorContent_outline report_content"
				>
					<p class="content_date">{{ item.event_issue_date }}</p>
					<p class="content_detail">
						{{ item.event_issue_content }}
					</p>
				</div>
				<button
					v-if="investReportPointData.event_disclosure.length > 5 && exposure.count_issue !== 10"
					class="c_button dark font-semi radius-x-small"
					@click="exposure.count_issue += 5"
				>
					<span>전체보기</span><img src="@/assets/img/common/arrow_down.svg" alt="더보기 아이콘" loading="lazy" />
				</button>
			</div>
			<div v-else class="emptyData_alert">데이터 없음</div>
		</div>
		<div v-if="investReportPointData?.event_disclosure" class="section_point">
			<h2 class="report_title">종목공시</h2>
			<div v-if="investReportPointData?.event_disclosure.length > 0" class="point_item">
				<div
					v-for="(item, index) in investReportPointData.event_disclosure
						.slice()
						.sort((a, b) => new Date(b.event_disclosure_date).getTime() - new Date(a.event_disclosure_date).getTime())
						.slice(0, exposure.count_disclose)"
					:key="`disclose${index}`"
					class="c_editorContent c_editorContent_outline report_content"
				>
					<p class="content_date">{{ item.event_disclosure_date }}</p>
					<p class="content_detail">
						{{ item.event_disclosure_content }}
					</p>
				</div>
				<button
					v-if="investReportPointData.event_disclosure.length > 5 && exposure.count_disclose !== 10"
					class="c_button dark font-semi radius-x-small"
					@click="exposure.count_disclose += 5"
				>
					<span>전체보기</span><img src="@/assets/img/common/arrow_down.svg" alt="더보기 아이콘" loading="lazy" />
				</button>
			</div>
			<div v-else class="emptyData_alert">데이터 없음</div>
		</div>
	</div>
</template>

<script setup lang="ts">
// lib
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

// api
import { useGetInvestReportPointApi } from '@/api/report';

// -----variable-----
const route = useRoute();
const exposure = ref({
	count_issue: 5,
	count_disclose: 5,
});

// -----api-----
const { data: investReportPointData, refetch: refetchInvestReportPoint } = useGetInvestReportPointApi(
	computed(() => {
		return {
			event_pk: String(route.params.eventPk),
		};
	})
);

onMounted(async () => {
	await refetchInvestReportPoint();
});
</script>

<style scoped lang="scss">
.wrap {
	display: flex;
	flex-direction: column;
	gap: 4.8rem;
}
.section_point {
	display: flex;
	flex-direction: column;
	gap: 2rem;
	.report_title {
		font-size: var(--font-s-x-large);
		font-weight: var(--font-w-bold);
		line-height: 2.387rem;
	}
	.point_item {
		display: flex;
		flex-direction: column;
		gap: 1rem;
		.report_content {
			display: flex;
			flex-direction: column;
			gap: 0.8rem;
			.content_date {
				color: var(--color-base-mid, #818393);
				font-size: var(--font-s-small);
				font-weight: var(--font-w-light);
				line-height: normal;
			}
			.content_detail {
				color: var(--color-base-white, #ffffff);
				font-size: var(--font-s-mid);
				font-weight: var(--font-w-light);
				line-height: 19px;
			}
		}
	}
}
.emptyData_alert {
	padding: 3.2rem 0rem;
	font-size: var(--font-s-regular);
	font-weight: var(--font-w-light);
	line-height: 1.2;
	text-align: center;
}
</style>
